import { STUBBED_FIND_FRIENDS } from '../stubbedData';
import { addActionsToConnections } from '../utils/belay_helpers';
import { getContactOfFriends } from '../../../utils/requests/belay_requests';

export const POPULATE_FIND_FRIENDS = 'POPULATE_FIND_FRIENDS';
export const populateFindFriends = () => {
  return (dispatch, getState) => {
    return getContactOfFriends()
      .then(resp => {
        dispatch({ type: POPULATE_FIND_FRIENDS, payload: addActionsToConnections(resp.contacts) });
      })
      .catch(err => {
        console.log('err', err);
      });
  };
};

export const initialFindFriendsState = {
  userConnections: []
};

export default function findFriends(state = initialFindFriendsState, action) {
  switch (action.type) {
    case POPULATE_FIND_FRIENDS:
      return {
        ...state,
        userConnections: action.payload
      };
    default:
      return state;
  }
}
